import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./about.css"
import anime from 'animejs/lib/anime.es.js';


const About = ( props ) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)
    /**
     * ARE WE STILL DOING ANIMATIONS.. IF NOT REMOVE ALL BELOW
     */
    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>WRAP-UP</h1>
                        <p className="underabout">
                            {props.children ? props.children : <span>
                                Federal agencies have made demonstrable progress 
                                modernizing their IT in recent years. Still, 
                                federal IT modernization is a continuous state 
                                agency must achieve to refresh their systems applications 
                                and services on an ongoing basis. 
                                The first SNG Live Speaker Series event of the year will 
                                focus on this theme of IT modernization, bringing together 
                                federal IT leaders to discuss their progress and the major 
                                challenges they still face modernizing legacy systems."
                            </span>
                            }
                        </p>
                    </div>
                    <div class="column extra_text">
                        
                        <p className="cpe">
                        {/*<b>Press:</b> Please submit a copy of your press credentials to <a href="mailto:events@scoopnewsgroup.com" target="_blank" className="pinkify">events@scoopnewsgroup.com</a> for consideration for press registration.*/}
                            <br /><br />
                        </p>
                    </div>
                    <div className="column grid2">
                        {/* TODO: Confirm no conflict exist index.js */}
                        {/*<AboutDetails items={props.details} />*/}
                        {/* <div className="date">
                            <h3><h4>Date:</h4> 02.18.20</h3>
                            <h3><h4>Location:</h4> SNG HQ</h3>
                        </div> */}
                        {/* Mobile.. Why can't we use one a element */}
                        {/* <a className="regmobwatch" href="http://carahsoft.adobeconnect.com/p4lxbzgl0tr8/?OWASP_CSRFTOKEN=0821f9096306cd366be837a7942286a59b997ad1e0f4fd46286f8cfdce01ec3f" target="_blank">WATCH NOW »</a> */}
                        
                        <a className={props.ctaClassNames} href="https://event.on24.com/wcc/r/3079073/AE4A96B96479FBC8EFDE6DF7E8043358" target="_blank">{props.ctaText}</a>
                    {/* <a className="reg" id="eventbrite-widget-modal-trigger-104362645482">REGISTER »</a> */}
                        <a className={props.ctaClassNamesMobile} href="https://event.on24.com/wcc/r/3079073/AE4A96B96479FBC8EFDE6DF7E8043358" target="_blank">{props.ctaText}</a>
                        <p className="cpemob">

                        {/*<b>Press:</b> Please submit a copy of your press credentials to <a href="mailto:events@scoopnewsgroup.com" target="_blank" className="pinkify">events@scoopnewsgroup.com</a> for consideration for press registration.<br /><br /> */}
                        </p>
                        <ReactModal 
                            className={styles.learnMoreModal}
                            overlayClassName="learnMoreOverlay"
                            isOpen={learnMoreModalState}
                            contentLabel="Navigation"
                            onRequestClose={hideLearnMoreModal}
                            aria={{
                                labelledby: "Navigation",
                                describedby: "Website navigation items"
                            }}
                            shouldReturnFocusAfterClose={false}
                            shouldFocusAfterRender={false}>
                        
                            <button className={styles.closeLearnMoreBut} onClick={hideLearnMoreModal}>&times;</button>
                            <div className={styles.menuWrap}>
                                <b>SNG Live 2020 IT Modernization</b> attendees are eligible to receive continuing professional education (CPE) credits. 
                                Attendees can earn a maximum of 4 CPE credits in information technology.<br /><br />

                                In order to verify your CPEs, please document your name on the CPE attendance sheet located at the registration desk onsite. Be sure to return to the registration desk to document your time out. If sign in and/or sign out times are not documented, FedScoop is unable to verify your attendance and therefore cannot award CPE credit. Additional details:
                                <br /><br />
                                <img src="https://www.fedscoop.com/events/data-cloud-summit/assets/images/cperegistry_logo.jpg" className="cpe-logo" />
                                Delivery Method: Group-Live
                                <br />
                                Program Level: Intermediate
                                <br />
                                Prerequisites: Recommend previous experience in IT and technology
                                <br />
                                Advance Preparation: No advance preparation necessary
                                <br />
                                Contact <a href="mailto:beka.troutman@scoopnewsgroup.com" className="cpe-mail">Beka Troutman</a> 
                                &nbsp;for details on obtaining CPE credits at the event.
                                <br /><br />
                                Scoop News Group is registered with the National Association of State Boards of Accountancy 
                                (NASBA) as a sponsor of continuing professional education on the National Registry of CPE Sponsors. 
                                State boards of accountancy have final authority on the acceptance of individual courses for CPE credit. 
                                Complaints regarding registered sponsors may be submitted to the National Registry of 
                                CPE Sponsors through its website: www.learningmarket.org
                            </div>
                        </ReactModal>
                    </div>
                    <div className="column grid3">
                        {props.sponsors.filter( (sponsor) => sponsor.event == props.sponsorEventName).length > 0 &&
                        <div className={props.sponsorsClassNames}>
                            <h1>SPONSOR</h1>
                            {/* { JSON.stringify( props.sponsors.filter( (sponsor) => sponsor.event == props.sponsorEventName) ) } */}
                            { props.sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = props.sponsors.filter( sponsor => sponsor.level == level && sponsor.event == props.sponsorEventName)
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a>
                                            </div>
                                            )}
                                        </div> : false
                                    )
                                }
                            )
                            }
                        </div>
                        }
                        {/*<div className="botbuttons">
                            <h2 className="sponsor" id="Sponsors">BECOME A SPONSOR</h2>
                            <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                            <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>
                    </div>*/}
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className={props.sponsorsClassNames}>
                    <h1>SPONSOR</h1>
                    { props.sponsorshipLevel ? props.sponsorshipLevel.map( 
                        ( level, index )  => {
                            let levelSponsors = props.sponsors.filter( sponsor => sponsor.level == level && sponsor.event == props.sponsorEventName)
                            let levelHasSponsors = levelSponsors.length > 0
                            return ( 
                                levelHasSponsors ? <div key={ index }>
                                    {levelSponsors.map( (sponsor, key ) => 
                                    <div className="logos">
                                        <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                            <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                        </a>
                                    </div>
                                    )}
                                </div> : false 
                            )
                        }
                    ) : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                    }
                </div>
            </div>
            {/*<div className="sponsormob">
                <div className="containfix">
                    <h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                    <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>
                </div>
                </div>*/}
            
        </section>
    )
}

const AboutDetails = ({ items=[] }) => {
    return items && <div className="date">
        {items.map( (item, index) => <h3><h4>{item.key}:</h4> {item.value}</h3> )}
    </div>
}

export default About